import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=607fb012&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=607fb012&scoped=true&lang=css&"
import style1 from "./Header.vue?vue&type=style&index=1&id=607fb012&lang=scss&scoped=true&"
import style2 from "./Header.vue?vue&type=style&index=2&id=607fb012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fb012",
  null
  
)

/* custom blocks */
import block0 from "./Header.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports